import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-198eb1e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-6 p-4 container mx-auto" }
const _hoisted_2 = { class: "space-y-4" }
const _hoisted_3 = { class: "flex gap-4 justify-between" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "mb-0" }, "RUH - Kategorier", -1))
const _hoisted_5 = {
  key: 0,
  class: "w-full flex flex-col divide-y"
}
const _hoisted_6 = {
  key: 1,
  class: "w-full md-col-span-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Messages = _resolveComponent("Messages")!
  const _component_HcButton = _resolveComponent("HcButton")!
  const _component_CategoryBox = _resolveComponent("CategoryBox")!
  const _component_CategoryForm = _resolveComponent("CategoryForm")!
  const _component_CardBody = _resolveComponent("CardBody")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Messages),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", null, [
          (_ctx.wideScreen || (!_ctx.selectedCategory && !_ctx.createNew))
            ? (_openBlock(), _createBlock(_component_HcButton, {
                key: 0,
                color: "green",
                type: "inertia-link",
                href: _ctx.route('rfp-categories.create'),
                disabled: _ctx.route().current('rfp-categories.create') ||
              (_ctx.wideScreen && _ctx.route().current('rfp-categories.index'))
              
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Ny kategori ")
                ]),
                _: 1
              }, 8, ["href", "disabled"]))
            : _createCommentVNode("", true),
          (!_ctx.wideScreen && (_ctx.selectedCategory || _ctx.createNew))
            ? (_openBlock(), _createBlock(_component_HcButton, {
                key: 1,
                color: "gray",
                type: "inertia-link",
                href: _ctx.route('rfp-categories.index')
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Avbryt ")
                ]),
                _: 1
              }, 8, ["href"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["grid gap-8", { 'md-grid-cols-3': _ctx.wideScreen }])
      }, [
        (_ctx.wideScreen || (!_ctx.selectedCategory && !_ctx.createNew))
          ? (_openBlock(), _createElementBlock("aside", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                return (_openBlock(), _createBlock(_component_CategoryBox, {
                  class: "w-full rounded-none",
                  key: category.id,
                  category: category,
                  selected: category.id === _ctx.selectedCategory?.id
                }, null, 8, ["category", "selected"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectedCategory || _ctx.createNew || _ctx.wideScreen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_Card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_CardBody, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_CategoryForm, {
                        category: _ctx.selectedCategory,
                        onDeleted: _ctx.onDeleted
                      }, null, 8, ["category", "onDeleted"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
}